// extracted by mini-css-extract-plugin
module.exports =  {"simplified-banner":"_32bbee5fda--simplified-banner--Z6uId","no-banner":"_32bbee5fda--no-banner--E8ux1"};